import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { combineLatest, Subscription } from 'rxjs';
import { selectIntegrantesCurrentEmpresa } from '../../../../roles/entity-integrante/entity-integrante.selectors';
import { selectAllNaturalezaJuridica } from '../../../entity-naturalezas-juridica/entity-naturalezas-juridica.selectors';
import { selectAllLaboratoriosFromCurrentEmpresa } from '../../../../actividades/entity-laboratorios/laboratorios.selectors';
import { selectAllTiposRol } from '../../../../roles/entity-tipos-rol/entity-tipos-rol.selectors';
import { selectEntidadesProductivaFromCurrentEmpresa } from '../../../entity-entidad-productiva/entity-entidades-productiva.selectors';
import { selectAllPersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.selectors';
import { selectAllPersonasFisica } from '../../../entity-personas-fisica/entity-personas-fisica.selectors';
import { VistaMisIntegrantesInput, createVistaIntegrante } from '../../models/vista-mis-integrantes.models';
import { Integrante } from '../../../../roles/integrante/integrante.model';
import { NaturalezaJuridica } from '../../../entity-naturalezas-juridica/naturalezas-juridica.model';
import { Laboratorio } from '../../../../actividades/entity-laboratorios/laboratorios.model';
import { TipoRol } from './../../../../../../../../registro-personas-empresas-lib/src/lib/tipos-rol/tipos-rol.model';
import { PersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.model';
import { EntidadesProductiva } from '../../../entity-entidad-productiva/entity-entidades-productiva.model';
import { PersonasFisica } from '../../../entity-personas-fisica/entity-personas-fisica.model';
import { Persona } from '@rpe/registro-personas-empresas-lib';
import { entityRolChangeRequest } from '../../../../roles/entity-roles/entity-roles.actions';
import { selectAllEstadosRol } from '../../../../roles/entity-estado-rol/entity-estados-rol.selectors';
import { EstadosRol } from '../../../../roles/entity-estado-rol/entity\'estados-rol.models';
import * as moment from 'moment';

@Component({
  selector: 'rpe-vista-mis-integrantes-container',
  templateUrl: './vista-mis-integrantes-container.component.html',
  styleUrls: ['./vista-mis-integrantes-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaMisIntegrantesContainerComponent implements OnInit, OnDestroy {
  private subscription: Subscription

  public vistaIntegrantesInput: VistaMisIntegrantesInput = createVistaIntegrante()

  estadosRol: EstadosRol[] = []

  constructor(
    private store: Store<State>,
    private cdr: ChangeDetectorRef

  ) { }

  ngOnInit(): void {
    this.subscription = combineLatest([
      this.store.select(selectIntegrantesCurrentEmpresa),
      this.store.select(selectAllNaturalezaJuridica),
      this.store.select(selectAllLaboratoriosFromCurrentEmpresa),
      this.store.select(selectAllTiposRol),
      this.store.select(selectEntidadesProductivaFromCurrentEmpresa),
      this.store.select(selectAllPersonasJuridica),
      this.store.select(selectAllPersonasFisica),
      this.store.select(selectAllEstadosRol)
    ])
      .subscribe(([integrantes, naturalezasJuridica, laboratorios, tiposRol, entidadesProductivas, personasJuridica, personasFisica, estadosRol]) => {
        this.vistaIntegrantesInput = {
          currentEmpresa: entidadesProductivas[0] as EntidadesProductiva,
          showIntegrantes: false,
          integrantes: integrantes as Integrante[],
          naturalezasJuridicas: naturalezasJuridica as NaturalezaJuridica[],
          laboratorios: laboratorios as Laboratorio[],
          tiposRol: tiposRol as TipoRol[],
          createdPersonaJuridica: this.getPersonaJuridica(personasJuridica as PersonasJuridica[], entidadesProductivas[0] as EntidadesProductiva) || null as PersonasJuridica,
          createdPersonaFisica: this.personaFisicaByEntidadProductiva(entidadesProductivas[0] as EntidadesProductiva, personasFisica as PersonasFisica[]) as PersonasFisica || null as PersonasFisica,
          backUrl: '/empresas/mi-empresa',
          rolEstado: estadosRol as EstadosRol[]
        }

        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  getPersonaJuridica(persona: PersonasJuridica[], entidadProductiva: EntidadesProductiva): PersonasJuridica {
    return persona.find((pj) => {
      return pj.id === entidadProductiva.persona_juridica_id;
    });
  }

  personaFisicaByEntidadProductiva(entidadProductiva: EntidadesProductiva, personasfisicas: PersonasFisica[]): PersonasFisica {
    return personasfisicas.find((pf) => { return pf.id === entidadProductiva.persona_fisica_id }) as PersonasFisica
  }

  personaByPersonaFisica(personaFisica: PersonasFisica, persona: Persona[]): Persona {
    return persona.find((p) => { return p.id === personaFisica.persona_id }) as Persona
  }

  personaJuridicaByEntidadProductiva(personasJuridica: PersonasJuridica[], entidadProductiva: EntidadesProductiva): PersonasJuridica {
    return personasJuridica.find((pj) => { return pj.id === entidadProductiva.persona_juridica_id }) as PersonasJuridica
  }
}
